import { render, staticRenderFns } from "./Computation.vue?vue&type=template&id=94f1e17e&"
import script from "./Computation.vue?vue&type=script&lang=js&"
export * from "./Computation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports